import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Text,
  Flex,
  ModalCloseButton,
  Button,
  Box,
  List,
  ListItem,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

type AlertTutorialModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const AlertTutorialModal: React.FC<AlertTutorialModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.insightAlert",
  });

  return (
    <Modal
      closeOnOverlayClick={false}
      size={"3xl"}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalCloseButton color="gray.500" />
        <ModalBody py="40px" px="32px" color="black">
          <Flex flexDir={"column"} gap="24px">
            <Flex alignItems="center" gap="24px">
              <Text fontSize="xl">{t("newAlertViaWpp")}</Text>
              <Text fontSize="md" color="#086AA9">
                {t("whatIsAndHowItWorks")}
              </Text>
            </Flex>

            <Text fontWeight={400} fontSize="16px" color="#71717A">
              {t("theBigDifference")}
            </Text>

            <Text fontWeight={400} fontSize="16px" color="#71717A">
              {t("withReady")}
              <b> {t("portClosureRisk")}</b> {t("moreComingSoon")}
            </Text>

            <Text fontWeight={400} fontSize="16px" color="#71717A">
              📱 {t("keepYourNumber")}
            </Text>

            <Box bg="#F6F6F6" p={5} borderRadius="md">
              <Text color="#086AA9" mb="5px">
                {t("exampleAlert")}
              </Text>
              <Text fontWeight="bold" fontSize="md" mb={3}>
                {`${t("alertIcon")} ${t("alertTitle")} ${t("inLocation")}`}
              </Text>
              <Text
                mb={2}
                dangerouslySetInnerHTML={{ __html: t("alertPeriod") as string }}
              />
              <Text fontWeight="semibold" mb={1}>
                {t("environmentalConditionsTitle")}
              </Text>
              <List spacing={1} pl={4} mb={3}>
                <ListItem>{t("environmentalConditionWaves")}</ListItem>
                <ListItem>{t("environmentalConditionWinds")}</ListItem>
              </List>
              <Text fontWeight="semibold" mb={1}>
                {t("expectedImpactsTitle")}
              </Text>
              <Text mb={3} color="#484848">
                {t("possibilityOfImpacts")}
              </Text>
              <Text>{t("alertNote")}</Text>
            </Box>

            <Button
              layerStyle="ocean"
              _hover={{ layerStyle: "ocean" }}
              onClick={onClose}
              width="100%"
            >
              {t("gotIt")}
            </Button>
          </Flex>
        </ModalBody>

        <ModalFooter pt={0} pl={2} pr={2} pb={0}></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
